export const agGridSomeRows = (gridApi, predicate) => {
  let someItemsAreTrue = false;
  gridApi.forEachNode((...args) => {
    if (predicate(...args)) {
      someItemsAreTrue = true;
    }
  });
  return someItemsAreTrue;
};
